export default __webpack_public_path__ + "./assets/background-desktop__2cd6f855acb95fce0dbbabc878152dc2.jpg";